import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import './Login.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Check if already logged in
  useEffect(() => {
    console.log('=== Login Page Mounted ===');
    const token = localStorage.getItem('token');
    console.log('Token on login page:', token ? '✅ Present' : '❌ Not present');

    if (token) {
      console.log('Token found, redirecting to dashboard');
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      console.log('Attempting login with:', { email });

      const response = await axios.post('https://codydealms.codydeasoftech.in/api/teacher/login', {
        email,
        password,
        device_type: 'WEB',
        fcm_token: 'web_dummy_token',
      });

      console.log('Login response:', response.data);

      if (response.data.status === true) {
        const loginToken = response.data.data.login_token;
        console.log('Token received:', loginToken);

        // Store token in localStorage
        localStorage.setItem('token', loginToken);

        // Verify it was stored
        const storedToken = localStorage.getItem('token');
        console.log('Token stored in localStorage:', storedToken ? '✅ Success' : '❌ Failed');

        await Swal.fire({
          title: 'Login Successful',
          text: response.data.message,
          icon: 'success',
          showConfirmButton: false,
          timer: 3000
        });

        console.log('Navigating to dashboard...');
        navigate('/dashboard', { replace: true });
      } else {
        Swal.fire({
          title: 'Login Failed',
          text: response.data.message || 'Something went wrong.',
          icon: 'error',
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error('Login error:', error);
      Swal.fire({
        title: 'Error',
        text: error?.response?.data?.message || 'Server error occurred.',
        icon: 'error',
        showConfirmButton: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form className="login-card" onSubmit={handleSubmit}>
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img
            src="/logo.png"
            alt="Barasat College Logo"
            style={{ width: '100px', height: '100px', objectFit: 'contain' }}
          />
          <h4 style={{ marginTop: '10px', fontWeight: 'bold', color: '#333' }}>
            Integrated Learning Management System
          </h4>
          <h5 style={{ marginTop: '10px', fontWeight: 'bold', color: '#333' }}>
            Barasat College (Teacher)
          </h5>
          <p className="login-hint text-muted">
            Fill all credentials carefully
          </p>
        </div>

        <div className="input-wrapper">
          <span className="icon"><i className="fas fa-envelope"></i></span>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
          />
        </div>

        <div className="input-wrapper" style={{ position: 'relative' }}>
          <span className="icon"><i className="fas fa-key"></i></span>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{ paddingRight: '40px' }}
            disabled={loading}
          />
          <span
            className="toggle-password"
            onClick={() => setShowPassword(!showPassword)}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer'
            }}
          >
            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
          </span>
        </div>

        <button type="submit" disabled={loading}>
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Logging in...
            </>
          ) : (
            'Login'
          )}
        </button>
      </form>
    </div>
  );
}

export default Login;
